import { Component, Input, ViewChild, output } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import DataSource from 'devextreme/data/data_source';
import { BdsRouteSegmentsService } from '../../services/bds-route-segments.service';

@Component({
    selector: 'bds-route-segments',
    templateUrl: './bds-route-segments.component.html',
    styleUrls: ['./bds-route-segments.component.css'],
})
export class BdsRouteSegmentsComponent {
    dataSource: DataSource;
    displayColumns: string[];
    selectedRowKeys: Array<number> = [];
    @Input() readOnly = false;
    segmentUpdated = output<any>();
    @ViewChild('dataGrid', { static: false }) dataGrid!: DxDataGridComponent;

    private originalByKey = new Map<string | number, any>();
    private currentEditingKey: string | number | null = null;
    private suppressNextCancelEmit = false;

    constructor(private routeSegmentService: BdsRouteSegmentsService) {
        this.dataSource = new DataSource({
            store: this.routeSegmentService.getODataStore(),
            paginate: true,
            pageSize: 10,
            expand: [],
        });
    }

    @Input() set routeCode(value: string) {
        // TODO Filter Active Status
        this.dataSource.filter(['routeCode', '=', value]);
    }

    onEditorPreparing(e: any) {
        if (e.parentType !== 'dataRow') return;
        if (e.dataField !== 'contractNo' && e.dataField !== 'benchmarkHours') return;
        const prevHandler = e.editorOptions?.onValueChanged;
        e.editorOptions.valueChangeEvent = 'input';
        e.editorOptions.onValueChanged = (args: any) => {
            e.setValue(args.value);
            const updatedRow = { ...e.row.data, [e.dataField]: args.value };
            this.segmentUpdated.emit(updatedRow);
            if (prevHandler) prevHandler(args);
        };
    }

    onEditingStart(e: any) {
        const key = e.data?.id ?? e.data?.segmentNo;
        this.currentEditingKey = key;
        this.originalByKey.set(key, JSON.parse(JSON.stringify(e.data)));
    }

    onEditCanceled() {
        if (this.suppressNextCancelEmit) {
            this.suppressNextCancelEmit = false;
            return;
        }
        const key = this.currentEditingKey;
        if (key == null) return;
        const original = this.originalByKey.get(key);
        if (original) {
            this.segmentUpdated.emit(original);
            this.originalByKey.delete(key);
        }
        this.currentEditingKey = null;
    }

    onRowUpdating(e: any) {
        e.cancel = true;
        Object.assign(e.oldData, e.newData);
        this.suppressNextCancelEmit = true;
        this.dataGrid.instance.cancelEditData();
        this.segmentUpdated.emit(e.oldData);
    }

    onRowUpdated(e: any) {
        this.segmentUpdated.emit(e.data);
    }
}
